/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Spend_NoteInputs */

const vi_shop_tier_spend_note = /** @type {(inputs: Shop_Tier_Spend_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng chi tiêu = tiền hàng các đơn web/Mini App ĐÃ GIAO của tài khoản, trừ phần hoàn; không tính ship, không gồm đơn tại cửa hàng. Mốc phải tăng dần, không trùng. Số khách đang ở hạng cập nhật mỗi đêm.`)
};

/**

* @param {Shop_Tier_Spend_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_spend_note = /** @type {((inputs?: Shop_Tier_Spend_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Spend_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_spend_note(inputs)
});